export default "__VITE_ASSET__BORhRj2I__"